import { RootState } from "@/shared/types";
import { IMrnCategoriesData, IGetManyMrnCategoriesParams } from "./types/interfaces";

export const selectMrnCategories = (state: RootState): IMrnCategoriesData =>
  state.mrnCategories.data;

export const selectParams = (state: RootState): IGetManyMrnCategoriesParams =>
  state.mrnCategories.params;
